import React from 'react';
import InputDate from './InputDate';

export default class FormDate extends React.Component {

    render() {
        const {
            col,
            meta,
            label,
            input,
            disabled,
            readOnly,
        } = this.props;

        return (
            <InputDate
                col={col}
                label={label}
                error={meta.error}
                value={input.value}
                onBlur={input.onBlur}
                touched={meta.touched}
                readOnly={readOnly}
                disabled={disabled}
                onChange={input.onChange}
                submitFailed={meta.submitFailed}
            />
        );
    }

}

FormDate.propTypes = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/FormDate.jsx